import React from 'react';
import { TreeDeciduous as LucideTreeDeciduous } from 'lucide-react';

interface TreeDeciduousProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const TreeDeciduous: React.FC<TreeDeciduousProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideTreeDeciduous width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default TreeDeciduous;
